import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AddressBookService } from './api/addressBook.service';
import { AddressBookContactService } from './api/addressBookContact.service';
import { AggregatorService } from './api/aggregator.service';
import { AqnApiKeyService } from './api/aqnApiKey.service';
import { AreaService } from './api/area.service';
import { CategoryService } from './api/category.service';
import { ClientService } from './api/client.service';
import { ClientRoutingServiceService } from './api/clientRoutingService.service';
import { ContentService } from './api/content.service';
import { ContentProviderService } from './api/contentProvider.service';
import { ContentTransactionLogsService } from './api/contentTransactionLogs.service';
import { CountryService } from './api/country.service';
import { IndustryService } from './api/industry.service';
import { IndustryDndService } from './api/industryDnd.service';
import { MapContentToServiceProividerService } from './api/mapContentToServiceProivider.service';
import { MapServiceToClientService } from './api/mapServiceToClient.service';
import { OperatorDetailsService } from './api/operatorDetails.service';
import { OperatorsService } from './api/operators.service';
import { ServiceService } from './api/service.service';
import { ServiceContentMapService } from './api/serviceContentMap.service';
import { ServiceDndSubscriptionService } from './api/serviceDndSubscription.service';
import { ServiceProviderService } from './api/serviceProvider.service';
import { ServiceProviderUploadedDocumentsMapService } from './api/serviceProviderUploadedDocumentsMap.service';
import { ServiceSubscribersService } from './api/serviceSubscribers.service';
import { ServiceTransactionLogsService } from './api/serviceTransactionLogs.service';
import { ShortCodeService } from './api/shortCode.service';
import { SmsDeliveryService } from './api/smsDelivery.service';
import { SqlDataMigrationService } from './api/sqlDataMigration.service';
import { TenantService } from './api/tenant.service';
import { UtilityService } from './api/utility.service';
import { VasProviderRolesService } from './api/vasProviderRoles.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AddressBookService,
    AddressBookContactService,
    AggregatorService,
    AqnApiKeyService,
    AreaService,
    CategoryService,
    ClientService,
    ClientRoutingServiceService,
    ContentService,
    ContentProviderService,
    ContentTransactionLogsService,
    CountryService,
    IndustryService,
    IndustryDndService,
    MapContentToServiceProividerService,
    MapServiceToClientService,
    OperatorDetailsService,
    OperatorsService,
    ServiceService,
    ServiceContentMapService,
    ServiceDndSubscriptionService,
    ServiceProviderService,
    ServiceProviderUploadedDocumentsMapService,
    ServiceSubscribersService,
    ServiceTransactionLogsService,
    ShortCodeService,
    SmsDeliveryService,
    SqlDataMigrationService,
    TenantService,
    UtilityService,
    VasProviderRolesService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
